export const FETCH_SHIFT_GROUPS = "FETCH_SHIFT_GROUPS";
export const FETCH_SHIFT_GROUPS_SUCCESS = "FETCH_SHIFT_GROUPS_SUCCESS";
export const FETCH_SHIFT_GROUPS_FAILURE = "FETCH_SHIFT_GROUPS_FAILURE";

export const CREATE_SHIFT_GROUP = "CREATE_SHIFT_GROUP";
export const CREATE_SHIFT_GROUP_SUCCESS = "CREATE_SHIFT_GROUP_SUCCESS";
export const CREATE_SHIFT_GROUP_FAILURE = "CREATE_SHIFT_GROUP_FAILURE";

export const UPDATE_SHIFT_GROUP = "UPDATE_SHIFT_GROUP";
export const UPDATE_SHIFT_GROUP_SUCCESS = "UPDATE_SHIFT_GROUP_SUCCESS";
export const UPDATE_SHIFT_GROUP_FAILURE = "UPDATE_SHIFT_GROUP_FAILURE";

export const DELETE_SHIFT_GROUP = "DELETE_SHIFT_GROUP";
export const DELETE_SHIFT_GROUP_SUCCESS = "DELETE_SHIFT_GROUP_SUCCESS";
export const DELETE_SHIFT_GROUP_FAILURE = "DELETE_SHIFT_GROUP_FAILURE";
